 
import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { BannerDataSchema } from '../../../../dashboard/components/utility/schema-defs';
import { BannerDataResponse } from '../../../models';
import { getBannerData } from '../../actions/actionType/schedule-maintenance/GetBannerDataTypes';
import {
  cleargetBannerData,
  getBannerDataFailure,
  getBannerDataStart,
  getBannerDataSuccessful
} from '../../actions/sagaActions/schedule-maintenance/GetBannerDataSagaActions';
import {
  GetBannerDataFailurePayload
} from '../../actions/types/schedule-maintenance/GetBannerDataTypes';
/**
 * Call Get metric summary by API
 * @returns api response
 */

export async function callGetBannerDataApi() {
  return apiWrapper.get<BannerDataResponse>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance/maintenance-alert`
  );
}

export function* getBannerDataApi() {
  yield put(cleargetBannerData());
  yield put(getBannerDataStart());
  try {
    const { responseBody: data, isError, error } = yield call(callGetBannerDataApi);

    if (isError) {
      throw error;
    }

    const apiResponse = BannerDataSchema.validate(data, {
      abortEarly: true
    });
    if (apiResponse.error) {
      throw new Error('No Response');
    } else {
      yield put(getBannerDataSuccessful(data));
    }
  } catch (error: unknown) {
    const obj: GetBannerDataFailurePayload = {
      error: 'Unable to load Maintenance Alert Data'
    };
    yield put(getBannerDataFailure(obj));
  }
}
/**
 * Saga Effect to consider latest request
 */
export function* GetBannerDataSaga() {
  yield takeLatest(getBannerData.FETCH_BANNER_DATA_REQUEST, getBannerDataApi);
}

export const getBannerDataSaga = [fork(GetBannerDataSaga)];
